module.exports = __webpack_public_path__ + "img/logo-invoice.3d2f0ff1.png";